import axios from 'axios';
import { store } from '../../store';
import * as actions from '../../store/actions';
import AwsTokenModel from '../../models/AwsTokenModel';
import moment from 'moment';
import apiService from '../apiService';

export default async function getToken() {
  try {
    let _token = getLocalTokenAndCompareDate();
    if (_token) return _token;

    _token = await getTokenApi();
    return _token;
  } catch (error) {
    console.error("Error getToken", error);
    throw error;
  }

  function getLocalTokenAndCompareDate() {
    let _token = AwsTokenModel(store.getState().awsToken);
    if (!_token.token || !_token.date) return "";

    let _reservedDate = moment(_token.date);
    let _diff = moment().diff(_reservedDate, "minutes");
    if (_diff > 25) return "";

    return _token.token;
  }

  async function getTokenApi() {
    const options = {
      url: `${apiService.getUrl().accreditation}file/getToken`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    const _ret = await axios(options);

    store.dispatch(
      actions.setAwsToken(
        AwsTokenModel({
          date: moment().toISOString(),
          token: _ret.data.data,
        })
      )
    );
    return _ret.data.data;
  }
}
